<div class="row" *ngIf="reservation">
	<mat-checkbox class="ms-3 mb-2" *ngIf="isAnyCancelledOffer" [(ngModel)]="service.showAllOffers">
		Pokaż wszystkie pokoje
	</mat-checkbox>
	<div class="col d-flex flex-column gap-4 app-reservation-summary-accommodation" cdkDropListGroup>
		<div
			class="alert-warning px-3 py-2 d-flex flex-row align-items-center justify-content-between"
			*ngIf="service.slotDragging"
		>
			<span class="col">Jesteś w trybie zamiany uczestników między pokojami!</span>
			<div class="d-flex flex-row justify-content-end gap-2">
				<button class="btn btn-outline-danger" (click)="cancelDraggingChanges()">Porzuć</button>
				<button class="btn btn-primary" (click)="submitSlotChanges()">Zapisz zmiany</button>
			</div>
		</div>
		<ng-container *ngIf="service.slotDragging">
			<div class="border border-2 border-warning d-flex flex-column p-1 gap-3">
				<app-reservation-summary-offer
					[offer]="offer"
					*ngFor="let offer of offers | async"
				></app-reservation-summary-offer>
			</div>
		</ng-container>
		<ng-container *ngIf="!service.slotDragging">
			<app-reservation-summary-offer
				[offer]="offer"
				*ngFor="let offer of offers | async"
			></app-reservation-summary-offer>
		</ng-container>
	</div>
</div>
